<template>
  <!-- READ ONLY MODE -->

  <div v-if="mode == 'VIEW'">
    <div v-if="!question.templateImageUrl">
      <div class="question-container">
        <span class="step" v-if="showStep">Step {{ question.stepSequence }}</span>
        <div class="instruction_title ql-editor p-0 mb-20" v-html="question.title"></div>
        <div class="instruction_info p-0" v-html="question.formattedInformation"></div>
        <div class="row mt-10">
          <div class="col-md-6 pl-0">
            <div class="th-activity-image-capture-question mt-20" v-if="question.imageUrl">
              <img class="display-image" :src="question.imageUrl" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row">
        <div class="pl-0 col-md-6">
          <div class="question-container flex-column">
            <span class="step" v-if="showStep">Step {{ question.stepSequence }}</span>
            <div class="image-content_title font_bold" v-html="question.title"></div>
            <div class="instruction_info p-0" v-html="question.formattedInformation"></div>
          </div>
          <div v-if="question.imageUrl">
            <img class="img-size" :src="question.imageUrl" />
          </div>
        </div>
        <div class="pl-0 col-md-6 col-lg-6">
          <div class="image-content_title font_bold ql-editor p-0">
            <p>Template Image</p>
          </div>
          <div class="view-template-image mt-15" v-if="question.templateImageUrl">
            <img class="template-image" :src="question.templateImageUrl" />
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- EDIT MODE -->

  <div v-else-if="mode == 'EDIT'" class="mb-40">
    <div class="link-text pt-10" data-toggle="modal" data-target="#instructionScreenExampleModal">
      Instruction screen example
    </div>
    <div class="pt-5">
      <div class>Screen title</div>
      <div v-if="!restrictAddHelp" @click="isAddHelpEnabled = !isAddHelpEnabled" class="th-activity-question-type-custom-scale-edit">
        <span
          class="add-help-text"
          :style="{
            color: isAddHelpEnabled ? 'rgba(0, 0, 0, 0.2)' : ''
          }"
        >
          Add Help
        </span>
      </div>
      <quill-editor class="bg-white mb-30" v-model="question.formattedTitle" :options="editorOptionForimageCaptureTitle"></quill-editor>
    </div>
    <!-- help content -->
    <div v-if="isAddHelpEnabled && !restrictAddHelp">
      <h5 class="answer">Help</h5>
      <quill-editor class="bg-white mt-30 mb-20" v-model="question.helpContent" :options="editorOptionForHelp" v-on:change="helpCharacterLimitValidation($event)"></quill-editor>
    </div>
    <div class="pt-20">
      <div class>Screen content</div>
      <div v-if="activityDetails.customParticipantMessaging" class="th-activity-question-type-custom-scale-edit" @click="toggleMessageTextInput">
        <span
          class="add-help-text"
          :style="{
            color: isAddMessageEnabled ? 'rgba(0, 0, 0, 0.2)' : ''
          }"
        >
          Add Message
        </span>
      </div>
      <quill-editor class="instruction-screen bg-white mb-30" ref="privacyPolicyEditor" v-model="question.formattedInformation" :options="editorOptionForimageCaptureScreen" @focus="onEditorFocus" @ready="onEditorReady($event)"></quill-editor>
      <div v-if="isAddMessageEnabled && activityDetails.customParticipantMessaging" class="row add_message_div mb-30">
        <div class="col-md-11 p-0">
          <h5 class="mt-10">Message</h5>
          <quill-editor v-model="question.messageBody" :options="editorOptionForMessage" class="bg-white mb-10 quill-score" @change="helpCharacterLimitValidation"></quill-editor>
        </div>
        <div class="col-md-1 p-0">
          <button class="btn btn-link color_red pl-0 pt-35" @click="toggleMessageTextInput(true)">
            <img src="static/img/delete.svg" />
          </button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 col-lg-6 p-0">
        <div class="row pt-20">
          <div class="pb-10">Image:</div>
          <div class="row">
            <div v-if="question.imageUrl" class="th-activity-image-capture-question col-xs-12 col-sm-2 col-md-4 col-lg-4 pl-0">
              <img class="img_size display-image" :src="question.imageUrl" />
              <a class="delete-telplate-image color_red cursor_pointer fs-15 mt-10 d-block" v-if="question.imageUrl" v-on:click="deleteimageUrl()">
                <i class="fa fa-trash fs-18" aria-hidden="true"></i>
              </a>
            </div>
            <div class="col-xs-12 col-sm-2 col-md-3 col-lg-3 p-0">
              <div class="file_container1">
                <span class="file_container_text1 upload-image-label">Upload</span>
                <input
                  type="file"
                  style="width: 100%"
                  class="form-control-file"
                  id="file_upload"
                  accept="image/*"
                  @change="
                    uploadInstructionImage($event);
                    return false;
                  "
                />
              </div>
            </div>
            <div class="col-xs-12 col-sm-2 col-md-5 col-lg-5">
              <span class="instruction">Recommended: 390px x 390px</span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-lg-6" v-show="question.guideParticipant">
        <div class="row pt-20">
          <div class="pb-10">Template Image:</div>
          <div class="row">
            <div v-if="question.templateImageUrl" class="th-question-type-image-capture-template-upload position-relative col-xs-12 col-sm-2 col-md-4 col-lg-4 pl-0">
              <img class="template-image img_size" :src="question.templateImageUrl" />
              <a class="delete-telplate-image color_red cursor_pointer fs-15 mt-10 d-block" v-if="question.templateImageUrl" v-on:click="deleteTemplateImage()">
                <i class="fa fa-trash fs-18" aria-hidden="true"></i>
              </a>
            </div>
            <div class="col-xs-12 col-sm-2 col-md-3 col-lg-3 p-0">
              <div class="file_container1">
                <span class="file_container_text1 upload-image-label">Upload</span>
                <input
                  type="file"
                  class="form-control-file"
                  id="template_file_upload"
                  accept=".png"
                  @change="
                    uploadInstructionTemplateImage($event, true);
                    return false;
                  "
                />
              </div>
              <div class="link-text" data-toggle="modal" data-target="#imageCpatureExampleModal">
                Template guide example
              </div>
            </div>
            <div class="col-md-1 col-lg-1">
              <div class="ml-3 instruction mt-5">or</div>
            </div>
            <div class="col-xs-12 col-sm-2 col-md-4 col-lg-4 p-0">
              <div class="file_container1">
                <button class="selectLibrary p-0" data-toggle="modal" data-target="#myModal">
                  <span class="file_container_text1 upload-image-label">Select from a library</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <activity-video-upload-modal ref="activityVideoUploadModal" @insertVideo="insertVideoInEditor" :question="question" :moduleName="onActivityModuleName" />
  </div>
</template>

<script>
import activityStepCustomMessage from "@/mixins/activity-step-custom-message";
import QlVideoUploadService from "@/services/ql-video-upload";
import localStorage from "@/services/localStorage";
import { Quill } from "vue-quill-editor";
import ActivityVideoUploadModal from "@/components/common/activity-video-upload-modal";
import { quillEditor } from "vue-quill-editor";

const MODULE_NAME = "activity";
export default {
  name: "ActivityStepImageCapture",

  mixins: [activityStepCustomMessage],

  props: {
    question: {},
    showStep: { type: Boolean },
    mode: {
      default: "VIEW"
    },
    commonProps: {},
    activityDetails: {},
    editorOptionForHelp: {
      type: Object
    },
    restrictAddHelp: {
      type: Boolean,
      default: false
    }
  },
  components: {
    ActivityVideoUploadModal,
    quillEditor
  },
  data() {
    return {
      logos: null,
      editorOptionForimageCaptureTitle: {
        placeholder: "Enter Title",
        modules: {
          toolbar: [[{ color: [] }, { background: [] }], ["bold", "italic", "underline", "link"], [{ list: "ordered" }, { list: "bullet" }], [{ header: [1, 2, 3, 4, 5, 6, false] }], [{ indent: "-1" }, { indent: "+1" }], [{ align: [] }], ["clean"]]
        }
      },
      editorOption: {
        placeholder: "Enter content for this topic",
        modules: {
          toolbar: [[{ color: [] }, { background: [] }], ["bold", "italic", "underline", "link"], [{ list: "ordered" }, { list: "bullet" }], [{ header: [1, 2, 3, 4, 5, 6, false] }], [{ indent: "-1" }, { indent: "+1" }], [{ align: [] }], ["clean"]]
        }
      },
      editorOptionForimageCaptureScreen: {
        placeholder: "Enter content for this topic",
        modules: {
          toolbar: {
            container: [[{ color: [] }, { background: [] }], ["bold", "italic", "underline", "link"], ["localVideoUpload"], [{ list: "ordered" }, { list: "bullet" }], [{ header: [1, 2, 3, 4, 5, 6, false] }], [{ indent: "-1" }, { indent: "+1" }], [{ align: [] }], ["clean"]],
            handlers: {
              localVideoUpload: this.customVideoButtonHandler
            }
          }
        }
      },
      isAddHelpEnabled: false,
      editorFocused: null,
      onActivityModuleName: MODULE_NAME
    };
  },
  watch: {
    isAddHelpEnabled() {
      this.question.isAddHelpEnabled = this.isAddHelpEnabled;
    }
  },
  mounted() {
    this.qlVideoUpload = new QlVideoUploadService(MODULE_NAME, this.$route.params.studyId, localStorage.getItem("clientId"));
    const VideoBlot = require("@/utils/quill-video-tag-blot");
    Quill.register(VideoBlot);
    this.$nextTick(() => {
      // The whole view is rendered, so I can safely access or query
      this.initLocalVideoUploadButton(); // initialize the audio icon so that it can be displayed
    });
    if (!this.restrictAddHelp) {
      this.isAddHelpEnabled = this.question.isAddHelpEnabled;
    }
    if (this.question.id === null) {
      this.question.isSkippable = true;
    }
  },
  methods: {
    helpCharacterLimitValidation(event, maxCount = 250) {
      const helpContent = event.quill;
      if (event.text.length > maxCount) {
        this.$toastr.error(`Character limit cannot exceed ${maxCount}.`);
      }
      helpContent.deleteText(maxCount, helpContent.getLength());
    },
    stripHtml(content) {
      const temporalDivElement = document.createElement("div");
      temporalDivElement.innerHTML = content;
      return temporalDivElement.innerText;
    },
    validateImage(image) {
      const isValid = image.name.match(/.(jpg|png|svg)$/i);
      return isValid;
    },
    validateTemplateImage(image) {
      const isValid = image.name.match(/.(png)$/i);
      return isValid;
    },
    uploadInstructionImage(event, isInstructionTemplate) {
      const self = this;
      const selectedImage = event.target.files[0];
      const input = window.document.getElementById("file_upload");
      if (input.files[0] && this.validateImage(input.files[0]) == null) {
        this.$toastr.error("Image upload failed. Please try again.");
        event.target.value = null;
        return;
      }
      const prevImageId = this.question && this.question.imageId ? this.question.imageId : "";
      const imageId = `img_id_${Math.random()
        .toString(36)
        .substr(2, 10)}`;
      const reader = new FileReader();
      reader.onload = e => {
        const file = {
          fileName: input.files[0].name,
          contentType: input.files[0].type,
          sequence: this.question.sequence,
          previousImageId: prevImageId,
          imageId: imageId,
          base64Code: e.target.result.split(",")[1]
        };
        this.$api.imageActivityUploadFact(this.activityDetails.id, file, isInstructionTemplate).then(
          response => {
            if (response.data.result.imageUrl) {
              self.$set(self.question, "imageUrl", response.data.result.imageUrl);
              self.$set(self.question, "imageId", response.data.result.imageId);
            } else if (response.data.result.templateImageUrl) {
              self.$set(self.question, "templateImageUrl", response.data.result.templateImageUrl);
              self.$set(self.question, "templateImageId", response.data.result.templateImageId);
            }
            this.$toastr.success("Image uploaded successfully");
            if (isInstructionTemplate) {
              window.$('#template_file_upload[type="file"]').val(null);
            } else {
              window.$('#file_upload[type="file"]').val(null);
            }
          },
          error => {
            self.errorMsg = error.body ? error.body.message : "Error while uploading the image.";
            this.$toastr.error(self.errorMsg);
            if (isInstructionTemplate) {
              self.question.templateImageUrl = "";
              self.question.templateImageId = "";
              window.$('#template_file_upload[type="file"]').val(null);
            } else {
              self.question.imageUrl = "";
              self.question.imageId = "";
              window.$('#file_upload[type="file"]').val(null);
            }
          }
        );
      };
      reader.readAsDataURL(selectedImage);
    },
    customVideoButtonHandler(val) {
      if (this.question && this.question.type && this.question.type === "SurveyInstruction") {
        this.editorFocused = this.$refs["privacyPolicyEditor"].quill;
      }
      if (val && this.editorFocused) {
        this.$refs.activityVideoUploadModal.show();
      }
    },
    insertVideoInEditor(data) {
      const length = this.editorFocused.getSelection() ? this.editorFocused.getSelection().index : this.editorFocused.selection.savedRange.index;
      this.editorFocused.insertEmbed(length, "uploadedVideo", data);
      this.editorFocused.setSelection(length + 1);
    },
    initLocalVideoUploadButton() {
      // initialize "custom upload" button style
      this.$nextTick(() => {
        const videoButton = document.querySelector(".ql-localVideoUpload"); // "QL -" is the prefix automatically added by the plug-in
        if (videoButton) {
          //Add a style and initialize the style of the icon with fontawesome
          videoButton.classList.add("fa");
          videoButton.classList.add("fa-video-camera");
          videoButton.style.cssText = "color: #999; padding: 6px";
        }
      });
    },
    onEditorReady(editor) {
      this.editorFocused = editor;
    },
    onEditorFocus(quill) {
      this.editorFocused = quill;
    },
    checkQuestionValidity() {
      const question = this.question;
      const errorObj = { isValid: true };

      if (question.formattedTitle && question.formattedInformation) {
        //Validate Title
        if (question.guideParticipant && !this.question.templateImageUrl) {
          errorObj.isValid = false;
          errorObj.msg = `Uploading or selecting an image is required when this box is checked.`;
          return errorObj;
        }
      } else if (this.stripHtml(question.formattedTitle) === "") {
        errorObj.msg = "Step title is required.";
        errorObj.isValid = false;
        return errorObj;
      } else if (this.stripHtml(question.formattedInformation) === "") {
        errorObj.msg = "Step content is required.";
        errorObj.isValid = false;
        return errorObj;
      } else {
        errorObj.isValid = false;
        errorObj.msg = `Step is required`;
        return errorObj;
      }
      if (question.isAddHelpEnabled && !this.restrictAddHelp && (!question.hasOwnProperty("helpContent") || this.stripHtml(question.helpContent).trim() === "")) {
        errorObj.isValid = false;
        errorObj.msg = "Help text is required for this step.";
        return errorObj;
      }

      if (question.isAddMessageEnabled && (!question.hasOwnProperty("messageBody") || this.stripHtml(question.messageBody).trim() === "")) {
        errorObj.isValid = false;
        errorObj.msg = "Message text is required for this step.";
        return errorObj;
      }
      return errorObj;
    },
    deleteTemplateImage() {
      this.question.templateImageUrl = "";
      this.question.templateImageId = "";
      this.$toastr.success("Image deleted successfully");
    },
    deleteimageUrl() {
      this.question.imageUrl = "";
      this.question.imageId = "";
      this.$toastr.success("Image deleted successfully");
    },
    uploadInstructionTemplateImage(event, isInstructionTemplate) {
      const self = this;
      const selectedImage = event.target.files[0];
      const input = window.document.getElementById("template_file_upload");
      if (input.files[0] && this.validateTemplateImage(input.files[0]) == null) {
        this.$toastr.error("Image upload failed. Please try again.");
        event.target.value = null;
        return;
      }
      const reader = new FileReader();
      const prevTemplateImageId = this.addEditQuestion && this.addEditQuestion.templateImageId ? this.addEditQuestion.templateImageId.substr(0, this.addEditQuestion.templateImageId.lastIndexOf(".")) : "";
      reader.onload = e => {
        const file = {
          fileName: input.files[0].name,
          contentType: input.files[0].type,
          sequence: this.addEditQuestion && this.addEditQuestion.sequence,
          templateImageId: `template_img_id_${Math.random()
            .toString(36)
            .substr(2, 10)}`,
          previousTemplateImageId: prevTemplateImageId,
          base64Code: e.target.result.split(",")[1]
        };
        this.$api.imageActivityUploadFact(this.activityDetails.id, file, isInstructionTemplate).then(
          response => {
            if (response.data.result.imageUrl) {
              self.$set(self.question, "templateImageUrl", response.data.result.imageUrl);
              self.$set(self.question, "templateImageId", response.data.result.imageId);
            }
            this.$toastr.success("Image uploaded successfully.");
            if (isInstructionTemplate) {
              window.$('#template_file_upload[type="file"]').val(null);
            } else {
              window.$('#file_upload[type="file"]').val(null);
            }
          },
          error => {
            self.errorMsg = error.body ? error.body.message : "Error while uploading the image.";
            this.$toastr.error(self.errorMsg);
            if (isInstructionTemplate) {
              self.question.templateImageUrl = "";
              self.question.templateImageId = "";
              window.$('#template_file_upload[type="file"]').val(null);
            } else {
              self.question.imageUrl = "";
              self.question.imageId = "";
              window.$('#file_upload[type="file"]').val(null);
            }
          }
        );
      };
      reader.readAsDataURL(selectedImage);
    }
  }
};
</script>

<style scoped lang="scss">
.selectLibrary {
  border-radius: 5px !important;
}
.file_container1 {
  margin-top: 0px !important;
}
.instruction_info {
  height: fit-content !important;
}
.upload-image-label {
  color: #666669;
  font-size: 13px;
  font-weight: bold;
}
.th-activity-image-capture-question {
  display: flex !important;
  align-items: center;
  justify-content: center;
  background-color: #ffffff;
  padding-right: 0px !important;
  margin-right: 15px;
  width: 125px !important;
  height: 120px !important;
  .display-image {
    max-height: 100% !important;
    max-width: 100% !important;
    padding: 11px;
  }
  .delete-telplate-image {
    position: absolute;
    top: 93px;
    right: -30px;
  }
}
.image-content_title {
  font-size: 14px;
  height: fit-content;
  color: #666669;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.template-image {
  padding-left: 0px !important;
  max-height: 100% !important;
  max-width: 100% !important;
}
.th-question-type-image-capture-template-upload {
  width: 125.2px !important;
  height: 126px !important;
  padding: 5px !important;
  background-color: #ececec;
  display: flex !important;
  align-items: center;
  margin-right: 15px;
  justify-content: center;
  .delete-telplate-image {
    position: absolute;
    top: 98px;
    right: -30px;
  }
}
.view-template-image {
  width: 151px;
  height: 152px;
  padding: 5px !important;
  background-color: #ececec;
  display: flex !important;
  align-items: center;
  margin-right: 15px;
  justify-content: center;
}
.radio-option {
  margin: 0px;
  label {
    padding-left: 5px;
  }
}
.integer-plus-minus-input {
  width: 2rem;
  border: none;
}
.add-help-text {
  right: 533px;
  top: -38px;
  padding: 12px 13px;
}
</style>
